import { createContext, useContext } from "react";


export const Analytics = createContext({
    
});

export function useAnalytics() {
    return useContext(Analytics);
};